module.exports = __webpack_public_path__ + "static/media/video-placeholder-1.9a3a7a74.jpg";